import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import {
  Button,
  ButtonGroup,
  Badge,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import { GoTerminal, GoKebabVertical } from "react-icons/go";
import { FiLogOut, FiPlay, FiToggleLeft, FiToggleRight } from "react-icons/fi";

import "./header.css";

const Header = ({ setSelectedCourse, handleSignOut }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [course, setCourse] = useState("React");

  const toggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const courseDropdown = (
    <ButtonDropdown
      isOpen={dropdownOpen}
      toggle={toggle}
      onClick={event => setSelectedCourse(event.target.innerText)}
    >
      <DropdownToggle caret color="link" className="text-white">
        Courses
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem>Javascript</DropdownItem>
        <DropdownItem>React</DropdownItem>
        <DropdownItem>Go</DropdownItem>
        <DropdownItem disabled>Angular</DropdownItem>
        <DropdownItem divider />
        <DropdownItem>Create Course</DropdownItem>
      </DropdownMenu>
    </ButtonDropdown>
  );

  return (
    <div className="header-container" style={{ width: "100%" }}>
      <div className="logo-container">
        {/* <GoTerminal className="p-1 logo-style" size={40} /> */}
        <GoTerminal className="p-0 logo-style" size={30} />
        <h4 className="text-start text-light">TLZ</h4>
      </div>
      <div className="menu-options-container">
        <div className="options-container">
          {/* <p className="menu-items">Courses</p> */}
          {courseDropdown}
          <p className="menu-items">Search</p>
        </div>
        <div className="login-signup-container">
          <Button
            color="link"
            className="menu-items"
            style={{
              color: "#fff"
            }}
          >
            Login
          </Button>
          <Button
            style={{
              backgroundColor: "#c8e6c9",
              color: "#000"
            }}
          >
            Signup
          </Button>
          <Button color="link" onClick={handleSignOut}>
            <FiLogOut className="p-0 logo-style" size={30} />
          </Button>
        </div>
      </div>
    </div>
  );
};

const LeftSubHeader = ({ courseTitle, toggle, homeView, loading }) => {
  const iconStatus =
    homeView === "List" ? (
      <FiToggleRight className="p-0 logo-style-dark" size={20} />
    ) : (
      <FiToggleLeft className="p-0 logo-style-dark" size={20} />
    );
  return (
    <div
      className="sub-header-container border rounded"
      style={{ width: "100%" }}
    >
      <h6 className="text-start">{courseTitle}</h6>

      <Button
        color="link"
        onClick={toggle}
        disabled={courseTitle === "Courses"}
      >
        {iconStatus}
      </Button>
    </div>
  );
};

const RightSubHeader = ({
  fileName,
  handleCode,
  handleThemeClick,
  theme,
  lines,
  fetchWebWorker
}) => (
  <div
    className="sub-header-container border rounded"
    // style={{ width: "100%" }}
  >
    {/* <div className="rt-sub-header-filename-container">
      <p className="text-start rt-sub-header-menu-items">{fileName}</p>
      <p className="rt-sub-header-menu-items">{lines}</p>
    </div>
    <div className="rt-sub-header-buttons-container">
      <Button color="link" onClick={handleCode}>
        <FiPlay className="p-0 logo-style-dark" size={20} />
      </Button>
    </div> */}

    <p className="text-start rt-sub-header-menu-items">{fileName}</p>
    <ButtonGroup>
      <Button
        size="sm"
        color="link"
        onClick={() => handleThemeClick("vs-light")}
        active={theme === "vs-light"}
      >
        <Badge
          color={theme === "vs-light" ? "dark" : "light"}
          style={{ fontSize: "12px", fontWeight: "normal" }}
        >
          Light
        </Badge>
      </Button>

      <Button
        size="sm"
        color="link"
        onClick={() => handleThemeClick("vs-dark")}
        active={theme === "vs-dark"}
      >
        <Badge
          color={theme === "vs-light" ? "light" : "dark"}
          style={{ fontSize: "12px", fontWeight: "normal" }}
        >
          Dark
        </Badge>
      </Button>
    </ButtonGroup>

    <Button color="link" onClick={handleCode}>
      <FiPlay className="p-0 logo-style-dark" size={20} />
    </Button>
  </div>
);

const RightSubHeaderBottom = () => (
  <div
    className="rt-sub-header-bottom-container border rounded"
    style={{ width: "100%" }}
  >
    {/* <Button color="link">
      <FiChevronsUp size={20} className="logo-style-dark" />
    </Button> */}
  </div>
);

Header.propTypes = {
  // siteTitle: PropTypes.string,
  setSelectedCourse: PropTypes.func,
  handleSignOut: PropTypes.func
};

// Header.defaultProps = {
//   siteTitle: ``
// };

//export { Header };
export { Header, LeftSubHeader, RightSubHeader, RightSubHeaderBottom };
